import { create } from 'zustand';

import { EventTypeBackend } from '../../../types/events.types';

export type ManageReverseVestingTarget = {
  eventId: string;
  eventType: EventTypeBackend;
  /** The row whose "⋮" menu was used — names the modal's subtitle only; every row is editable. */
  transactionId: string;
};

type ManageReverseVestingState = {
  clearTarget: () => void;
  close: () => void;
  isOpen: boolean;
  open: (target: ManageReverseVestingTarget) => void;
  target: ManageReverseVestingTarget | null;
};

/**
 * The action lives on a transaction row inside the history table, four component layers below the
 * page that owns the modal, and the tables take their callbacks as a fixed prop contract shared by
 * every event type. A store keeps this one type-specific action out of that contract.
 *
 * `target` survives `close()` so the sheet can play its close animation with its content intact,
 * and is dropped with `clearTarget()` once the animation ends. A target left behind keeps the
 * modal's event query alive for as long as the page is mounted: an edit that recreates the event
 * under a new id (or a delete) then refetches the dead id on every settle and toasts
 * "Event not found".
 */
export const manageReverseVestingStore = create<ManageReverseVestingState>()((set) => ({
  isOpen: false,
  target: null,
  open: (target) => set({ isOpen: true, target }),
  close: () => set({ isOpen: false }),
  clearTarget: () => set((state) => (state.isOpen ? state : { target: null })),
}));
